export default "__VITE_ASSET__lpghXf1R__"